/**
 * Created by sswaminathan on 10/20/22
 * File: TransFormLicenseResponse
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

/**
 *   TODO: Brief what is this component/class do
 */

const TransFormLicenseResponse = (response) => {
  const licenseDetails = []
  if (response?.['de_hash']?.data)
    licenseDetails.push(response?.['de_hash']?.data)

  if (response?.['claimed_license']?.length) {
    licenseDetails.push(...response?.['claimed_license'])
  }
  const message = response?.['de_hash']?.message === 'Success' ? '' : response?.['de_hash']?.message ?? ''
  return { message, response: licenseDetails }
}

TransFormLicenseResponse.propTypes = {}
export default TransFormLicenseResponse
